import { isAgritourPublicSlice, isPathAllowedInPublicSlice } from '@/lib/public-slice';
import UnavailableScreen from '@/screens/Unavailable/UnavailableScreen';
import type { ReactNode } from 'react';

interface PublicSliceGuardProps {
  pathname: string;
  children: ReactNode;
}

/** Blocks hidden portal routes when VITE_PUBLIC_SLICE=agritour. */
export default function PublicSliceGuard({ pathname, children }: PublicSliceGuardProps) {
  if (!isAgritourPublicSlice()) {
    return children;
  }

  if (isPathAllowedInPublicSlice(pathname)) {
    return children;
  }

  return <UnavailableScreen />;
}
